const host = window.location.hostname;

/** Per-host API and image URLs. Add new deployments here without changing existing ones. */
const HOST_CONFIG = {
  localhost: {
    base_url: "http://localhost:52476/api/",
    images: "https://api.fuelbook.pk/images/",
  },
  "nd.petrol-pump.com": {
    base_url: "http://localhost:52476/api/",
    images: "https://api.fuelbook.pk/images/",
  },
  "app1.zakipetroleum.com": {
    base_url: "https://app1api.zakipetroleum.com/api/",
    images: "https://app1api.zakipetroleum.com/images/",
  },
};

/** Production default (app.fuelbook.pk and other existing hosts). */
const DEFAULT_CONFIG = {
  base_url: "https://api.fuelbook.pk/api/",
  images: "https://api.fuelbook.pk/images/",
};

const { base_url, images } = HOST_CONFIG[host] || DEFAULT_CONFIG;

const config = {
  base_url,
  images,
  date_format: "DD MMM YYYY",
};

export default config;
